import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';

import * as fromRoot from '../../../reducers';
import { LoaderService } from '../../loading/loader.service';
import { HealthCenterSailingInfo } from '../../../models/session';
import { GatingServices } from '../../core/services/gating.services';
import { BookingService } from '../../core/services/booking.service';
import { MicroServicesService } from '../../core/services/micro-services.service';
import { ResourceBundleService } from '../../core/services/resource-bundle.service';
import { IHealthCenterProtocolsResponse } from '../../../models/governance-content.payload';

@Component({
    selector: 'app-health-center',
    templateUrl: './health-center.container.html',
    standalone: false
})
export class HealthCenterContainerComponent implements OnInit {
	brandName: string;
	urlPrefix : string;
	bundle$: Observable<any>;
	healthCenterProtocolsResp$: Observable<IHealthCenterProtocolsResponse>;
	reservationRetrievalResponse$: Observable<HealthCenterSailingInfo> | any;

	constructor(
		private readonly store: Store<fromRoot.AppState>,
		private gatingService: GatingServices,
		private microservice: MicroServicesService,
		public bookingService: BookingService,
		public resourceBundle: ResourceBundleService,
		public loaderService: LoaderService,
	) {
		this.bundle$ = this.resourceBundle.bundle;
		this.brandName = this.bookingService.getBrand();
		this.urlPrefix = this.microservice.apiUrl;
	}

	ngOnInit(): void {
		setTimeout(() => {
			this.loaderService.hideLoader();
		}, 2000);

		const olciDataCookie = this.gatingService.getOlciDataCookie();
		this.healthCenterProtocolsResp$ = this.microservice.getHealthCenterProtocols({
			shipCode: olciDataCookie.shipCode,
			sailDate: olciDataCookie.sailDate
		});

		this.reservationRetrievalResponse$ = this.store.pipe(select(fromRoot.getHealthCenterSailingInfo));
	}
}
